import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import React from 'react';
import './style.scss';

interface LoadingProps {
  color?: string;
  size?: number;
  className?: string;
}

const Loading: React.FC<LoadingProps> = ({
  size = 16,
  color,
  className = '',
}) => {
  return (
    <Spin
      className="loading"
      indicator={
        <LoadingOutlined
          className={className}
          style={{ fontSize: size, color }}
          spin
        />
      }
    />
  );
};

export default Loading;
